//import {gsap, Quart} from 'gsap/all';
import utils from '@/_modules/utils';
import textWrap from '@/_modules/common/textWrap';

class _topMv {
  //constructor() {}
  init() {
    this.el = document.getElementById('p-top__mv');
    this.pastWidth = 0;

    // タイトルアニメーション
    const titleLines = this.el.querySelectorAll('h1 > .is-transition');
    titleLines.forEach((el, i) => {
      el.innerHTML = textWrap.wraSpan(el.textContent);
    });

    // mvスクロールボタン
    this.bindScroll = this.anchorMv.bind(this);
    this.btnScroll = document.getElementById('c-scroll');
    this.btnScroll.addEventListener('click', this.bindScroll);

    // リサイズ
    this.bindResize = this.resize.bind(this);
    this.bindResize();
    window.addEventListener('resize', this.bindResize, {passive: false});
  }

  reset() {
    this.btnScroll.removeEventListener('click', this.bindScroll);
    delete this.bindScroll;
    delete this.btnScroll;

    window.removeEventListener('resize', this.bindResize);
    delete this.bindResize;
    delete this.el;
    delete this.pastWidth;
  }

  start() {
    this.el.classList.add('is-anim-start');
  }

  anchorMv(e) {
    e.preventDefault();
    window.$scroll.scrollTo(window.innerHeight, {
      offset: 0,
      callback: function() {},
      duration: 500,
      easing: [0.165, 0.84, 0.44, 1],
    });
  }

  resize() {
    const winW = window.innerWidth;
    if (utils.getMatchMedia() && winW === this.pastWidth) return;
    utils.fit(this.el, true, window.innerWidth, window.innerHeight, 0, 0);
    this.pastWidth = window.innerWidth;
  }
}

const topMv = new _topMv();

export default topMv;